import React, { useState, useEffect } from "react";
import {
  UncontrolledDropdown,
  CardBody,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  CardHeader,
  Card,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Badge,
} from "reactstrap";
import { api } from "../../../../api";
import Cookies from "js-cookie";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import * as XLSX from "xlsx";

const Materials = () => {
  // const [filteredData, setFilteredData] = useState([]);
  const [dataToShow, setDataToShow] = useState([]);
  const [materialShow, setMaterialShow] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");

  const toggleModalAdd = () => setModalAdd((prevState) => !prevState);
  const [modalAdd, setModalAdd] = useState(false);
  const [clientForm, setClientForm] = useState({});
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteProjectName, setDeleteProjectName] = useState("");

  const [entriesToShow, setEntriesToShow] = useState(5);
  const [projectDropdownOpen1, setProjectDropdownOpen1] = useState(false);
  const [projectDropdownOpen2, setProjectDropdownOpen2] = useState(false);
  const [selectedProjectName, setSelectedProjectName] = useState("Select Project");
  const [baseData, setBaseData] = useState([]);

  // Filter states
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [materialNameFilter, setMaterialNameFilter] = useState("");
  const [materialFilterDropdownOpen, setMaterialFilterDropdownOpen] = useState(false);
  const [dateRangeModalOpen, setDateRangeModalOpen] = useState(false);
  const [materialSearchQuery, setMaterialSearchQuery] = useState("");

  const toggleProjectDropdown2 = () => {
    setProjectDropdownOpen2(!projectDropdownOpen2);
  };

  const shopName = [
    { value: "Low", label: "Low" },
    { value: "High", label: "High" },
  ];
  const projects = ["Project 1", "Project 2", "Project 3", "Project 4"];

  const handleDeleteConfirmation = (confirmed, deleteInfo) => {
    if (confirmed) {
      if (deleteInfo.type === "multiple") {
        // Multiple data: POST request with array of IDs
        const fetchData = async () => {
          try {
            if (!company_id) {
              throw new Error('Missing company_id in cookies');
            }
            const response = await api.post(`deleteMaterial.php?company_id=${company_id}`, {
              ids: deleteInfo.value
            });
            console.log(response.data);
            window.location.reload();
          } catch (error) {
            console.error("Error deleting multiple data:", error);
          }
        };
        fetchData();
      } else if (deleteInfo.type === "m_id") {
        // Single data: GET request with m_id
        const fetchData = async () => {
          try {
            if (!company_id) {
              throw new Error('Missing company_id in cookies');
            }
            const response = await api.get(`deleteMaterial.php?id=${deleteInfo.value}&company_id=${company_id}`);
            console.log(response.data);
            // Optionally refresh data
            window.location.reload();
          } catch (error) {
            console.error("Error deleting single data:", error);
          }
        };
        fetchData();
      }
    }
    setShowDeleteConfirmation(false);
  };

  const company_id = Cookies.get('company_id');
  const emp_id = Cookies.get("token") || Cookies.get("emp_id");
  console.log("Current emp_id from cookies:", emp_id);
  console.log("Current company_id from cookies:", company_id);

  const [modalOpen, setModalOpen] = useState(false);
  const toggleModalView = () => {
    setModalOpen(!modalOpen);
  };
  const [modalEmployee, setModalEmployee] = useState(null);

  const [project, setproject] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!company_id || !emp_id) {
          throw new Error('Missing company_id or emp_id in cookies');
        }
        const response = await api.get(
          `viewProjectDetails.php?p_m_id=${emp_id}&company_id=${company_id}`
        );
        const data = Array.isArray(response.data) ? response.data : []; // Ensure it's an array
        setproject(data);
        console.log(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const [projectmanager, setprojectmanager] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!company_id) {
          throw new Error('Missing company_id in cookies');
        }
        const response = await api.post(`employeesView.php?company_id=${company_id}`);
        // Filter to show only General Managers from the current company
        const generalManagers = response.data.filter(emp => 
          emp.role === 'General Manager' && emp.company_id === company_id
        );
        setprojectmanager(generalManagers);
        console.log("General Managers for company:", generalManagers);
      } catch (error) {
        console.error("Error fetching data:", error);
        setprojectmanager([]);
      }
    };
    fetchData();
  }, [company_id]);

  const [reqmaterial, setreqmaterial] = useState({
    emp_id: emp_id,
    mat_name: "",
    mat_price: "",
    mat_priority: "",
    mat_quantity: "",
    p_id: "",
    g_m_id: "",
    files: [],
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setreqmaterial((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    console.log(reqmaterial);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setreqmaterial((prevState) => ({
      ...prevState,
      files: file,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!company_id || !emp_id) {
      setSuccessMessage('Missing employee ID or company ID. Please refresh the page and try again.');
      setShowSuccessAlert(true);
      return;
    }

    // Required fields validation
    if (!reqmaterial.p_id || !reqmaterial.g_m_id || !reqmaterial.mat_name || !reqmaterial.mat_quantity || !reqmaterial.mat_priority || !reqmaterial.mat_price) {
      setSuccessMessage('Please fill all required fields.');
      setShowSuccessAlert(true);
      return;
    }

    // Set loading state
    setIsSubmitting(true);
    setFormError("");

    const formDataToSend = new FormData();
    formDataToSend.append("emp_id", reqmaterial.emp_id);
    formDataToSend.append("company_id", company_id);
    formDataToSend.append("p_id", reqmaterial.p_id);
    formDataToSend.append("mat_name", reqmaterial.mat_name);
    formDataToSend.append("mat_quantity", reqmaterial.mat_quantity);
    formDataToSend.append("mat_priority", reqmaterial.mat_priority);
    formDataToSend.append("mat_price", reqmaterial.mat_price);
    const files = reqmaterial.files; // Assuming reqmaterial.files is a FileList or an array of File objects

    for (let i = 0; i < files.length; i++) {
      formDataToSend.append("files[]", files[i]);
    }
    formDataToSend.append("g_m_id", reqmaterial.g_m_id);

    try {
      const response = await api.post(`materialrequest.php?company_id=${company_id}`, formDataToSend);
      console.log("Data sent successfully:", response.data);
      setSuccessMessage("Material request submitted successfully!");
      setShowSuccessAlert(true);
      toggleModalAdd();
      // Reset form
      setreqmaterial({
        emp_id: emp_id,
        mat_name: "",
        mat_price: "",
        mat_priority: "",
        mat_quantity: "",
        p_id: "",
        g_m_id: "",
        files: [],
      });
    } catch (error) {
      console.error("Error submitting data:", error);
      setSuccessMessage(error.response?.data?.message || "Failed to submit material request. Please try again.");
      setShowSuccessAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const [allmaterial, setallmaterial] = useState();
  useEffect(() => {
  const fetchData = async () => {
    try {
      if (!company_id || !emp_id) {
        throw new Error('Missing company_id or emp_id in cookies');
      }
      console.log("Fetching data for emp_id:", emp_id, "company_id:", company_id);
      
      // Fetch only Project Manager's data
      const response1 = await api.get(`materialrequest.php?emp_id=${emp_id}&company_id=${company_id}`);
      console.log("Material request response:", response1.data);
      const arr1 = Array.isArray(response1.data) ? response1.data.filter(item => {
        console.log("Checking material request item emp_id:", item.emp_id, "against current emp_id:", emp_id);
        return item.emp_id == emp_id; // Use == for type coercion
      }) : [];
      
      const response2 = await api.get(`uploadMaterials.php?emp_id=${emp_id}&company_id=${company_id}`);
      console.log("Upload materials response:", response2.data);
      const arr2 = Array.isArray(response2.data) ? response2.data.filter(item => {
        console.log("Checking uploaded item emp_id:", item.emp_id, "against current emp_id:", emp_id);
        return item.emp_id == emp_id; // Use == for type coercion
      }) : [];
      
      const combined = [...arr1, ...arr2];
      console.log("Filtered data for Project Manager:", combined);
      
      // Sort combined data by Date_Time in descending order (most recent first)
      const sortedCombined = combined.sort((a, b) => {
        const dateA = new Date(a.Date_Time);
        const dateB = new Date(b.Date_Time);
        return dateB - dateA; // Descending order (newest first)
      });
      
      setAllData(sortedCombined);
      setMaterialShow(sortedCombined);
      setBaseData(sortedCombined);
      setDataToShow(sortedCombined.slice(0, entriesToShow));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  fetchData();
}, []);

  useEffect(() => {
  const fetchData = async () => {
    try {
      if (!company_id || !emp_id) {
        throw new Error('Missing company_id or emp_id in cookies');
      }
      // Fetch only Project Manager's uploaded materials
      const response = await api.get(`uploadMaterials.php?emp_id=${emp_id}&company_id=${company_id}`);
      const arr = Array.isArray(response.data) ? response.data : [];
      
      // Sort uploaded materials by Date_Time in descending order
      const sortedArr = arr.sort((a, b) => {
        const dateA = new Date(a.Date_Time);
        const dateB = new Date(b.Date_Time);
        return dateB - dateA; // Descending order (newest first)
      });
      
      setDataToShow(prev => {
        const combined = [...(Array.isArray(prev) ? prev : []), ...sortedArr];
        return combined.sort((a, b) => {
          const dateA = new Date(a.Date_Time);
          const dateB = new Date(b.Date_Time);
          return dateB - dateA; // Descending order (newest first)
        });
      });
      setMaterialShow(prev => {
        const combined = [...(Array.isArray(prev) ? prev : []), ...sortedArr];
        return combined.sort((a, b) => {
          const dateA = new Date(a.Date_Time);
          const dateB = new Date(b.Date_Time);
          return dateB - dateA; // Descending order (newest first)
        });
      });
      setBaseData(prev => {
        const combined = [...(Array.isArray(prev) ? prev : []), ...sortedArr];
        return combined.sort((a, b) => {
          const dateA = new Date(a.Date_Time);
          const dateB = new Date(b.Date_Time);
          return dateB - dateA; // Descending order (newest first)
        });
      });
      console.log("Project Manager's uploaded materials:", arr);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  fetchData();
}, []);

 const handleProjectSelection = async (p_id, p_name) => {
  try {
    if (!company_id || !emp_id) {
      throw new Error('Missing company_id or emp_id in cookies');
    }
    if (p_id) {
      setSelectedProjectName(p_name);
      const response = await api.get(
        `materialrequest.php?p_id=${p_id}&emp_id=${emp_id}&company_id=${company_id}`
      );
      let projectData = Array.isArray(response.data) ? response.data : [];
      const response2 = await api.get(
        `uploadMaterials.php?p_id=${p_id}&emp_id=${emp_id}&company_id=${company_id}`
      );
      let uploadData = Array.isArray(response2.data) ? response2.data : [];
      const combined = [...projectData, ...uploadData];
      
      // Sort combined data by Date_Time in descending order (most recent first)
      const sortedCombined = combined.sort((a, b) => {
        const dateA = new Date(a.Date_Time);
        const dateB = new Date(b.Date_Time);
        return dateB - dateA; // Descending order (newest first)
      });
      
      setBaseData(sortedCombined);
      setCurrentPage(1);
    } else {
      setSelectedProjectName("All");
      setBaseData(allData); // <-- use allData here
      setCurrentPage(1);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [showWasteFields, setShowWasteFields] = useState(false);
  const [showReplaceFields, setShowReplaceFields] = useState(false);
  const [allData, setAllData] = useState([]);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [formError, setFormError] = useState("");
  const [isImporting, setIsImporting] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Multiple materials modal states
  const [isMultipleMaterials, setIsMultipleMaterials] = useState(false);
  const [multipleMaterialsData, setMultipleMaterialsData] = useState(null);
  const [modalCurrentPage, setModalCurrentPage] = useState(1);
  const [modalEntriesPerPage, setModalEntriesPerPage] = useState(5);
  const [modalEntriesDropdownOpen, setModalEntriesDropdownOpen] = useState(false);
  
  // Carousel states for multiple materials modal (reusing existing ones)

  // Apply filters function - moved before filteredData declaration
  const applyFilters = (data) => {
    let filtered = [...data];

    // Apply date range filter
    if (startDate || endDate) {
      filtered = filtered.filter(item => {
        if (item.Date_Time) {
          // Parse the item date and normalize to YYYY-MM-DD format
          const itemDate = new Date(item.Date_Time);
          const itemDateStr = itemDate.toISOString().split('T')[0]; // Get YYYY-MM-DD format
          
          if (startDate && endDate) {
            // Both start and end date selected
            // Normalize both dates to YYYY-MM-DD format for accurate comparison
            const startDateStr = startDate; // Already in YYYY-MM-DD format
            const endDateStr = endDate; // Already in YYYY-MM-DD format
            
            // For same day selection (start === end), we want to include the entire day
            if (startDateStr === endDateStr) {
              return itemDateStr === startDateStr;
            } else {
              return itemDateStr >= startDateStr && itemDateStr <= endDateStr;
            }
          } else if (startDate) {
            // Only start date selected - from start date to current date
            const startDateStr = startDate;
            return itemDateStr >= startDateStr;
          } else if (endDate) {
            // Only end date selected - from beginning to end date
            const endDateStr = endDate;
            return itemDateStr <= endDateStr;
          }
        }
        return false;
      });
    }

    // Apply material name filter
    if (materialNameFilter) {
      filtered = filtered.filter(item => {
        const materialName = item.mat_name || item.mat_fileName || '';
        return materialName.toLowerCase().includes(materialNameFilter.toLowerCase());
      });
    }

    return filtered;
  };

// Apply search filter first
const searchFilteredData = searchQuery.trim()
  ? baseData.filter(
      (item) => {
        const searchTerm = searchQuery.toLowerCase();
        
        // Check all possible field names for material name
        const materialName = (
          item.mat_name?.toLowerCase() || 
          item.mat_fileName?.toLowerCase() || 
          ""
        );
        
        // Check all possible field names for quantity
        const quantity = (
          item.mat_quantity?.toString().toLowerCase() || 
          ""
        );
        
        // Check all possible field names for price/money
        const price = (
          item.mat_money?.toString() || 
          ""
        );
        
        // Check date/time
        const dateTime = (
          item.Date_Time?.toString() || 
          ""
        );
        
        return (
          materialName.includes(searchTerm) ||
          quantity.includes(searchTerm) ||
          price.includes(searchTerm) ||
          dateTime.includes(searchTerm) ||
          // Also check if any other field contains the search term
          Object.values(item).some(value => 
            value?.toString().toLowerCase().includes(searchTerm)
          )
        );
      }
    )
  : baseData;

// Apply additional filters (date range and material name)
const filteredData = applyFilters(searchFilteredData).sort((a, b) => {
  const dateA = new Date(a.Date_Time);
  const dateB = new Date(b.Date_Time);
  return dateB - dateA; // Descending order (newest first)
});

// Debug log for search
useEffect(() => {
  console.log("Search Query:", searchQuery);
  console.log("Base Data Length:", baseData.length);
  console.log("Filtered Data Length:", filteredData.length);
  
  // Debug: Log sample data structure to understand field names
  if (baseData.length > 0) {
    console.log("Sample data structure:", baseData[0]);
    console.log("Available fields:", Object.keys(baseData[0]));
  }
}, [searchQuery, baseData, filteredData, startDate, endDate, materialNameFilter]);

const totalPages = Math.ceil(filteredData.length / entriesToShow);

useEffect(() => {
  setDataToShow(
    filteredData.slice(
      (currentPage - 1) * entriesToShow,
      currentPage * entriesToShow
    )
  );
}, [filteredData, entriesToShow, currentPage]);



  const toggleProjectDropdown = () => {
    setProjectDropdownOpen(!projectDropdownOpen);
  };

  const toggleProjectDropdown1 = () => {
    setProjectDropdownOpen1(!projectDropdownOpen1);
  };

  const toggleDateRangeModal = () => {
    setDateRangeModalOpen(!dateRangeModalOpen);
  };

  const toggleMaterialFilterDropdown = () => {
    setMaterialFilterDropdownOpen(!materialFilterDropdownOpen);
  };

  const handleEntriesChange = (value) => {
    setEntriesToShow(value === "All" ? filteredData.length : Number(value));
    setCurrentPage(1);
  };

  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const getSerialNumber = (index) => {
    return (currentPage - 1) * entriesToShow + index + 1;
  };

  const changeCPage = (n) => {
    setCurrentPage(n);
  };

  // Get unique material names for filter dropdown with search
  const getUniqueMaterialNames = () => {
    let names = [...new Set(baseData.map(item => item.mat_name || item.mat_fileName).filter(Boolean))];
    
    // Apply search filter if there's a search query
    if (materialSearchQuery.trim()) {
      names = names.filter(name => 
        name.toLowerCase().includes(materialSearchQuery.toLowerCase())
      );
    }
    
    return names.sort();
  };


  // Clear all filters
  const clearFilters = () => {
    setStartDate("");
    setEndDate("");
    setMaterialNameFilter("");
    setMaterialSearchQuery("");
  };

  // Apply date range filter
  const applyDateRange = () => {
    setDateRangeModalOpen(false);
  };

  // Get date range display text
  const getDateRangeText = () => {
    if (startDate && endDate) {
      return `Date: ${new Date(startDate).toLocaleDateString()} - ${new Date(endDate).toLocaleDateString()}`;
    } else if (startDate) {
      return `From: ${new Date(startDate).toLocaleDateString()}`;
    } else if (endDate) {
      return `Until: ${new Date(endDate).toLocaleDateString()}`;
    }
    return "Filter by Date Range";
  };

  // Multiple materials functions
  const handleDownloadMultipleMaterials = () => {
    if (!multipleMaterialsData) return;

    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "multiple_materials_list";

    const materialsForExport = multipleMaterialsData.materials.map((material, index) => ({
      "Sr. No": index + 1,
      "Material Name": material.mat_name || "N/A",
      "Quantity": material.mat_quantity || "N/A",
      "Budget": material.mat_money || "N/A",
      "Unit Price": parseFloat(material.mat_money) || 0,
      "Total": (parseFloat(material.mat_quantity) || 0) * (parseFloat(material.mat_money) || 0)
    }));

    const ws = XLSX.utils.json_to_sheet(materialsForExport);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], { type: fileType });
    const excelUrl = URL.createObjectURL(excelData);
    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };

  const getModalPaginatedMaterials = () => {
    const startIndex = (modalCurrentPage - 1) * modalEntriesPerPage;
    const endIndex = startIndex + modalEntriesPerPage;
    return multipleMaterialsData.materials.slice(startIndex, endIndex);
  };

  const getModalTotalPages = () => {
    return Math.ceil(multipleMaterialsData.materials.length / modalEntriesPerPage);
  };

  const handleModalPageChange = (page) => {
    setModalCurrentPage(page);
  };

  const handleModalEntriesChange = (value) => {
    setModalEntriesPerPage(value === "All" ? multipleMaterialsData.materials.length : Number(value));
    setModalCurrentPage(1);
  };

  const getModalSerialNumber = (index) => {
    return (modalCurrentPage - 1) * modalEntriesPerPage + index + 1;
  };

  // Carousel functions for multiple materials modal (reusing existing ones)

  // Generate carousel slides for multiple materials modal
  const getCarouselSlides = () => {
    if (!multipleMaterialsData?.metadata?.files) return [];
    
    const imagesString = multipleMaterialsData.metadata.files;
    const imagesArray = imagesString ? imagesString.split(",") : [];

    return imagesArray
      .map((image, index) => {
        try {
          return (
            <CarouselItem
              onExiting={() => setAnimating(true)}
              onExited={() => setAnimating(false)}
              key={index}
            >
              <div
                className="profile-image-container"
                style={{
                  width: "376px",
                  height: "256px",
                  border: "2px solid black",
                  borderRadius: "9%",
                  overflow: "hidden",
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                  margin: "0 auto",
                }}
              >
                <img
                  alt={`Uploaded Image ${index + 1}`}
                  src={window.location.hostname === 'localhost'
                      ? require(`../../../images/${image}`)
                      : `/images/${image}`}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
              <CarouselCaption captionText="" captionHeader="" />
            </CarouselItem>
          );
        } catch (error) {
          console.error(`Image ${image} not found`);
          return null;
        }
      })
      .filter((slide) => slide !== null);
  };

useEffect(() => {
  setCurrentPage(1);
}, [searchQuery]);

  // const [profileImages, setProfileImages] = useState([]);
  // const handleFileUpload = (event) => {
  //       const files = event.target.files;
  //       const fileList = Object.values(files);
  //       setProfileImages(prevImages => [...prevImages, ...fileList]);
  //       console.log(fileList);
  // };

  const style = () => {
    const nextIcon = document.querySelector(".carousel-control-next-icon");
    if (nextIcon) {
      nextIcon.style.backgroundColor = "black";
    }

    const prevIcon = document.querySelector(".carousel-control-prev-icon");
    if (prevIcon) {
      prevIcon.style.backgroundColor = "black";
    }
  };
  style();
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [profileImages, setProfileImages] = useState([]);

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === profileImages.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? profileImages.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    const uploadedImagesArray = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();
      reader.onload = function (e) {
        const path = URL.createObjectURL(file);

        uploadedImagesArray.push({ name: file.name, data: path });
        if (uploadedImagesArray.length === files.length) {
          setProfileImages(prevImages =>
            Array.isArray(prevImages)
              ? [...prevImages, ...files]
              : [...files]
          );
        }
      };
      console.log(uploadedImagesArray);
      reader.readAsDataURL(file);
    }

    setreqmaterial((prev) => ({
      ...prev,
      files: [
        ...(Array.isArray(prev.files) ? prev.files : []),
        ...files
      ],
    }));
  };

  const [requestOption, setRequestOption] = useState("");
  const [modalImport, setModalImport] = useState(false);
  const toggleModalImport = () => setModalImport(!modalImport);

  const handleRequestOptionChange = (e) => {
    setRequestOption(e.target.value);
    if (e.target.value === "single") {
      toggleModalAdd();
    } else if (e.target.value === "multiple") {
      toggleModalImport();
    }
  };

  const handleImportSubmit = async (e) => {
    e.preventDefault();
  
    if (!importedFile) {
      setSuccessMessage("Please upload a file.");
      setShowSuccessAlert(true);
      return;
    }
  
    // Required fields validation for import
    if (!reqmaterial.p_id || !reqmaterial.g_m_id || !reqmaterial.mat_priority) {
      setSuccessMessage('Please fill all required fields.');
      setShowSuccessAlert(true);
      return;
    }

    // Additional validation for API requirements
    if (!emp_id || !company_id) {
      setSuccessMessage('Missing employee ID or company ID. Please refresh the page and try again.');
      setShowSuccessAlert(true);
      return;
    }
  
    // Debug logging
    console.log("Import data:", {
      emp_id,
      company_id,
      p_id: reqmaterial.p_id,
      p_id_type: typeof reqmaterial.p_id,
      p_id_number: Number(reqmaterial.p_id),
      g_m_id: reqmaterial.g_m_id,
      mat_priority: reqmaterial.mat_priority,
      fileName: importedFile.name
    });
  
    // Set loading state
    setIsImporting(true);
    setFormError("");
  
    const formData = new FormData();
    formData.append('importFile', importedFile);
    formData.append('p_id', reqmaterial.p_id);
    formData.append('g_m_id', reqmaterial.g_m_id);
    formData.append('mat_priority', reqmaterial.mat_priority);
    formData.append('emp_id', emp_id);
    formData.append('company_id', company_id);
  
    try {
      const response = await api.post(`uploadMaterials.php?company_id=${company_id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log("Import successful:", response.data);
      setSuccessMessage(response.data.message || "File imported successfully!");
      setShowSuccessAlert(true);
      toggleModalImport();
      // Reset form
      setImportedFile(null);
      setImportedFileDetails(null);
      setreqmaterial({
        emp_id: emp_id,
        mat_name: "",
        mat_price: "",
        mat_priority: "",
        mat_quantity: "",
        p_id: "",
        g_m_id: "",
        files: [],
      });
    } catch (error) {
      console.error("Error importing file:", error);
      setSuccessMessage(error.response?.data?.error || "Failed to import file. Please try again.");
      setShowSuccessAlert(true);
    } finally {
      setIsImporting(false);
    }
  };
      const [importedFile, setImportedFile] = useState(null);
      const [importedFileDetails, setImportedFileDetails] = useState(null);
      const handleImportFileUpload = (e) => {
        const file = e.target.files[0];
        const allowedTypes = [
          "application/vnd.ms-excel", // .xls
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
          "text/csv", // .csv
        ];
    
        if (file) {
          // Check file type
          if (!allowedTypes.includes(file.type)) {
            setSuccessMessage("Please upload only .csv, .xls, or .xlsx files");
            setShowSuccessAlert(true);
            e.target.value = ""; // Clear the file input
            setImportedFileDetails(null);
            return;
          }
    
          setImportedFile(file);
          setImportedFileDetails({
            fileName: file.name,
            fileType: file.type,
            fileSize: file.size,
            uploadTime: new Date().toLocaleString(),
          });
        }
      };
    

  const slides = profileImages.map((image, index) => (
    <CarouselItem
      onExiting={() => setAnimating(true)}
      onExited={() => setAnimating(false)}
      key={index}
    >
      <div
        className="profile-image-container"
        style={{
          width: "376px",
          height: "256px",
          border: "2px solid black",
          borderRadius: "9%",
          overflow: "hidden",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
          margin: "0 auto",
        }}
      >
        <img
          src={image.data}
          alt={`Uploaded Image ${index + 1}`}
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </div>
      <CarouselCaption captionText={image.name} captionHeader="" />
    </CarouselItem>
  ));

  const images = [
    "../../../images/65e867cb84c92_platter-2009590_960_720 copy.jpg",
    "../../../images/65e867cb84c92_platter-2009590_960_720.jpg",
  ];
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const [activeIndex1, setActiveIndex1] = useState(0);
  const imagesString = modalEmployee?.files;
  const imagesArray = imagesString ? imagesString.split(",") : [];

  const next1 = () => {
    if (animating || imagesArray.length === 0) return;
    const nextIndex =
      activeIndex1 === imagesArray.length - 1 ? 0 : activeIndex1 + 1;
    setActiveIndex1(nextIndex);
  };

  const previous1 = () => {
    if (animating || imagesArray.length === 0) return;
    const nextIndex =
      activeIndex1 === 0 ? imagesArray.length - 1 : activeIndex1 - 1;
    setActiveIndex1(nextIndex);
  };

  const goToIndex1 = (newIndex) => {
    if (animating || imagesArray.length === 0) return;
    setActiveIndex1(newIndex);
  };

  const slides1 = imagesArray
    .map((image, index) => {
      // Check if the image exists
      let imgSrc = "";
    try {
      imgSrc =
        window.location.hostname === "localhost"
          ? require(`../../../images/${image}`)
          : `/images/${image}`;
    } catch (error) {
      // Handle the case where the image doesn't exist (only relevant for localhost)
      console.error(`Image ${image} not found`);
      return null; // Skip this slide if image not found
    }

      return (
        <CarouselItem
          onExiting={() => setAnimating(true)}
          onExited={() => setAnimating(false)}
          key={index}
        >
          <div
            className="profile-image-container"
            style={{
              width: "376px",
              height: "256px",
              border: "2px solid black",
              borderRadius: "9%",
              overflow: "hidden",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
              margin: "0 auto",
            }}
          >
            <img
              id=""
              alt={`Uploaded Image ${index + 1 + image}`}
              src={window.location.hostname === 'localhost'
                  ? require(`../../../images/${image}`)
                  : `/images/${image}`}
              style={{
                width: "100%",
                height: "100%",
              }}
            />
          </div>
          <CarouselCaption captionText="" captionHeader="" />
        </CarouselItem>
      );
    })
    .filter((slide) => slide !== null); // Filter out null values

  return (
    <>
          <div className="header bg-gradient-info py-7 py-lg-8">
            <Container fluid>
              <Row className="mb-5">
                <Col>
                  <Dropdown
  isOpen={projectDropdownOpen}
  toggle={toggleProjectDropdown}
>
  <DropdownToggle caret>
    {selectedProjectName}
  </DropdownToggle>
  <DropdownMenu left>
    <DropdownItem
      onClick={() => handleProjectSelection()}
    >
      All
    </DropdownItem>
    {Array.isArray(project) && project.length > 0 ? (
      project.map((project) => (
        <DropdownItem
          key={project.p_id}
          onClick={() => handleProjectSelection(project.p_id, project.p_name)}
        >
          {project.p_name}
        </DropdownItem>
      ))
    ) : (
      <p>No Project Yet?</p>
    )}
  </DropdownMenu>
</Dropdown>
                </Col>
                <Col className="order-xl-2 mb-5 mb-xl-0 text-left ">
                  <h1>Materials Details</h1>
                </Col>
    
                <Col className="order-xl-2 mb-5 mb-xl-0 d-flex ">
                  <Form className="navbar-search  form-inline ml-5 d-none d-md-flex ml-lg-auto ">
                    <FormGroup className="mb-0 ml-2">
                      <InputGroup className="input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" style={{color: 'black'}}/>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Search Materials"
                          type="text"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Form>
                </Col>
              </Row>
              <Row className="">
                <Col
                  className="mb-5 mb-xl-0"
                  xl="12"
                  style={{ marginTop: "-20px" }}
                >
                  <Card className="" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                    <CardBody>
                      <CardHeader className="border-0">
                        <Row className="align-items-left">
                          <div className="col">
                            <div className="col text-right">
                              <div className="d-flex justify-content-end align-items-center ">
                                {/* Date Range Filter */}
                                <div className="mr-2 mb-2">
                                  <Button
                                    size="sm"
                                    color="info"
                                    onClick={toggleDateRangeModal}
                                    style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                                    className="px-3"
                                  >
                                    <i className="fas fa-calendar-alt mr-1"></i>
                                    {getDateRangeText()}
                                  </Button>
                                </div>

                                {/* Material Name Filter */}
                                <div className="mr-2 mb-2">
                                  <Dropdown
                                    isOpen={materialFilterDropdownOpen}
                                    toggle={toggleMaterialFilterDropdown}
                                  >
                                    <DropdownToggle caret className="px-3">
                                      {materialNameFilter ? `Material: ${materialNameFilter}` : "Filter by Material"}
                                    </DropdownToggle>
                                    <DropdownMenu style={{ width: '300px', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                                      {/* Search Bar Inside Dropdown */}
                                      <div className="mb-2">
                                        <Input
                                          type="text"
                                          placeholder="Search materials..."
                                          value={materialSearchQuery || ''}
                                          onChange={(e) => setMaterialSearchQuery(e.target.value)}
                                          style={{ fontSize: '13px', height: '32px' }}
                                        />
                                      </div>
                                      <DropdownItem 
                                        onClick={() => {
                                          setMaterialNameFilter("");
                                          setMaterialSearchQuery("");
                                        }}
                                        style={{ padding: '6px 12px', fontSize: '13px' }}
                                      >
                                        All Materials
                                      </DropdownItem>
                                      {getUniqueMaterialNames().length > 0 ? (
                                        getUniqueMaterialNames().map((name, index) => (
                                          <DropdownItem
                                            key={index}
                                            onClick={() => {
                                              setMaterialNameFilter(name);
                                              setMaterialSearchQuery("");
                                            }}
                                            style={{ 
                                              padding: '6px 12px', 
                                              fontSize: '13px',
                                              backgroundColor: materialNameFilter === name ? '#f8f9fa' : 'transparent',
                                              fontWeight: materialNameFilter === name ? 'bold' : 'normal'
                                            }}
                                          >
                                            {name}
                                          </DropdownItem>
                                        ))
                                      ) : (
                                        <DropdownItem disabled style={{ padding: '6px 12px', fontSize: '13px' }}>
                                          <small className="text-muted">No materials found</small>
                                        </DropdownItem>
                                      )}
                                    </DropdownMenu>
                                  </Dropdown>
                                </div>

                                {/* Clear Filters Button */}
                                {(startDate || endDate || materialNameFilter) && (
                                  <div className="mr-2 mb-2">
                                    <Button
                                      size="sm"
                                      color="secondary"
                                      onClick={clearFilters}
                                      className="px-3"
                                    >
                                      Clear Filters
                                    </Button>
                                  </div>
                                )}

                                <div className="mr-3">
                                                                     <Dropdown
                                     isOpen={projectDropdownOpen1}
                                     toggle={toggleProjectDropdown1}
                                   >
                                     <DropdownToggle caret>
   Show Entries:{" "}
   {entriesToShow === filteredData.length ? "All" : entriesToShow}
 </DropdownToggle>
                                    <DropdownMenu>
                                      <DropdownItem
                                        onClick={() => handleEntriesChange(5)}
                                      >
                                        5
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={() => handleEntriesChange(10)}
                                      >
                                        10
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={() => handleEntriesChange("All")}
                                      >
                                        All
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </Dropdown>
                                </div>
                                <Dropdown
                                  isOpen={projectDropdownOpen2}
                                  toggle={toggleProjectDropdown2}
                                >
                                  <DropdownToggle caret>
                                    Request Materials
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem
                                      onClick={() =>
                                        handleRequestOptionChange({
                                          target: { value: "" },
                                        })
                                      }
                                    >
                                      Request Materials
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() =>
                                        handleRequestOptionChange({
                                          target: { value: "single" },
                                        })
                                      }
                                    >
                                      Add Single Material
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() =>
                                        handleRequestOptionChange({
                                          target: { value: "multiple" },
                                        })
                                      }
                                    >
                                      Import Multiple Datas
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </div>
                            </div>
                          </div>
                        </Row>
                      </CardHeader>
                      <Table className="align-items-center table-flush" responsive>
                        <thead className="thead-light">
                          <tr>
                            <th scope="col">SL.No</th>
                            <th scope="col">Project Name</th>
                            <th scope="col">Material Name</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Price</th>
                            <th scope="col">Date/time</th>
                            <th scope="col">Status</th>
                            <th scope="col">View</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(dataToShow) && dataToShow.length > 0 ? (
                            dataToShow.map((item, index) => (
                              <tr key={index}>
                                <th scope="row">{getSerialNumber(index)}</th>
                                <td>{item.p_name || "N/A"}</td>
                                <td>{item.mat_name || item.mat_fileName}</td>
                                <td>{item.mat_quantity||"N/A"}</td>
                                <td>{item.mat_money||"N/A"}</td>
                                <td>{item.Date_Time}</td>
                                <td>
                                  <Badge
                                    style={{
                                      backgroundColor:
                                        (item.store_status || item.mat_status || "").trim().toLowerCase() === "approved"
                                          ? "#28a745" // green
                                          : ["rejected", "reject"].includes((item.store_status || item.mat_status || "").trim().toLowerCase())
                                          ? "#dc3545" // red
                                          : "#F7D800", // yellow for pending/others
                                      color: "black"
                                    }}
                                    className="p-2"
                                  >
                                    {item.store_status || item.mat_status}
                                  </Badge>
                                </td> 
                                <td>
                                  <button
                                    style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                                    onClick={() => {
                                      if(item.mat_data){
                                        const matData = JSON.parse(item.mat_data);
                                        
                                        // Check if this is multiple materials (more than 1)
                                        if (matData.length > 1) {
                                          // Multiple materials - show table view
                                          const multipleData = {
                                            materials: matData,
                                            metadata: {
                                              Priority: item.Priority,
                                              Date_Time: item.Date_Time,
                                              mat_status: item.mat_status,
                                              store_status: item.store_status,
                                              gm_report: item.gm_report,
                                              store_report: item.store_report,
                                              files: item.files
                                            }
                                          };
                                          setMultipleMaterialsData(multipleData);
                                          setIsMultipleMaterials(true);
                                          setModalCurrentPage(1);
                                          setModalEntriesPerPage(5);
                                        } else {
                                          // Single material - show regular view
                                          const merged = {
                                            mat_name: matData[0].mat_name,
                                            mat_money: matData[0].mat_money,
                                            mat_quantity: matData[0].mat_quantity,
                                            Priority: item.Priority,
                                            Date_Time: item.Date_Time,
                                            mat_status: item.mat_status,
                                            store_status: item.store_status,
                                            gm_report: item.gm_report,
                                            store_report: item.store_report,
                                            files: item.files
                                          };
                                          setModalEmployee(merged);
                                          setIsMultipleMaterials(false);
                                        }
                                      } else {
                                        // Single material from regular request
                                        setModalEmployee(item);
                                        setIsMultipleMaterials(false);
                                      }
                                      toggleModalView();
                                    }}
                                    className="btn btn-deeppink"
                                  >
                                    <Tippy content='View Material'>
                                      <i className="fa-solid fa-eye" ></i>
                                    </Tippy>
                                  </button>
                                  {/* <button
                                    onClick={() => {
                                      if (item.mat_id) {
                                        setDeleteProjectName({ type: "mat_id", value: item.mat_id });
                                      } else if (item.m_id) {
                                        setDeleteProjectName({ type: "m_id", value: item.m_id });
                                      }
                                      setShowDeleteConfirmation(true);
                                    }}
                                    className="btn btn-deeppink"
                                  >
                                    <Tippy content='Delete Material'>
                                      <i class="fa-solid fa-trash text-danger"></i>
                                    </Tippy>
                                  </button> */}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td style={{ textAlign: "center" }} colSpan="8">
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
    
                      <nav className="mt-3">
                        <ul className="pagination justify-content-center">
                          <li className="page-item">
                            <a
                              href="#"
                              className="page-link text-primary"
                              onClick={prePage}
                              disabled={currentPage === 1}
                            >
                              Prev
                            </a>
                          </li>
                          <li className="page-item">
                            <a
                              href="#"
                              className="page-link text-primary"
                              onClick={nextPage}
                              disabled={currentPage === totalPages}
                            >
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
          <Modal isOpen={modalAdd} toggle={toggleModalAdd}>
            <ModalHeader toggle={toggleModalAdd}>Add Materials</ModalHeader>
            <Form onSubmit={handleFormSubmit} encType="multipart/form-data">
              <Row className="px-3">
                <Col md={12}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-status">
                      Project Name
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-status"
                      type="select"
                      name="p_id"
                      onChange={handleInputChange}
                      value={reqmaterial.p_id}
                      required
                    >
                      <option value="">Select Project Name</option>
                      {project && project.length > 0 ? (
                        project.map((option) => (
                          <option key={option.p_id} value={option.p_id}>
                            {option.p_name}
                          </option>
                        ))
                      ) : (
                        <option value="">No projects available</option>
                      )}
                    </Input>
                  </FormGroup>
                </Col>
    
                <Col md={12}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-status">
                      General Manager
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-status"
                      type="select"
                      name="g_m_id"
                      onChange={handleInputChange}
                      value={reqmaterial.g_m_id}
                      required
                    >
                      <option value="">Select General Manager</option>
                      {Array.isArray(projectmanager) &&
                      projectmanager.length > 0 ? (
                        projectmanager.map((option) => (
                          <option key={option.emp_id} value={option.emp_id}>
                            {option.emp_name + " [" + option.role + "]"}
                          </option>
                        ))
                      ) : (
                        <option value="">No General Managers available</option>
                      )}
                    </Input>
                  </FormGroup>
                </Col>
    
                <Col md={12}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-name">
                      Material Name
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-material"
                      type="text"
                      name="mat_name"
                      onChange={handleInputChange}
                      placeholder="Material Name"
                      value={reqmaterial.mat_name}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-name">
                      Material Quantity
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-material"
                      type="text"
                      name="mat_quantity"
                      onChange={handleInputChange}
                      placeholder="Material Quantity"
                      value={reqmaterial.mat_quantity}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-status">
                      Materials Priority{" "}
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-status"
                      type="select"
                      name="mat_priority"
                      onChange={handleInputChange}
                      value={reqmaterial.mat_priority}
                      required
                    >
                      <option value="">Select Priority</option>
                      {shopName.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-budget">
                      Material Price
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-budget"
                      type="number"
                      name="mat_price"
                      onChange={handleInputChange}
                      placeholder="Material Price"
                      value={reqmaterial.mat_price}
                      required
                    />
                  </FormGroup>
                </Col>
    
                <Col md={12}>
                  <label className="form-control-label" htmlFor="input-budget">
                    Upload Images
                  </label>
    
                  <Carousel
                    activeIndex={activeIndex}
                    next={next}
                    previous={previous}
                  >
                    <CarouselIndicators
                      items={profileImages.map((_, index) => ({ key: index }))}
                      activeIndex={activeIndex}
                      onClickHandler={goToIndex}
                    />
                    {slides}
                    {profileImages.length > 0 && (
                      <CarouselControl
                        direction="prev"
                        directionText="Previous"
                        onClickHandler={previous}
                        style={{ backgroundColor: "black" }}
                      />
                    )}
                    {profileImages.length > 0 && (
                      <CarouselControl
                        direction="next"
                        directionText="Next"
                        onClickHandler={next}
                      />
                    )}
                  </Carousel>
                </Col>
                <Col lg="12" className="text-left m-2">
                  <Button
                    style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white'}}
                    onClick={() =>
                      document.getElementById("input-profile-image").click()
                    }
                  >
                    Upload
                  </Button>
    
                  <FormGroup style={{ display: "none" }}>
                    <Input
                      type="file"
                      id="input-profile-image"
                      accept="image/*"
                      onChange={handleFileUpload}
                      multiple
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg="12" className="text-center mb-2">
                  <Button 
                    style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white'}} 
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <i className="fas fa-spinner fa-spin mr-2"></i>
                        Submitting...
                      </>
                    ) : (
                      'Submit'
                    )}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Modal>
    
          <Modal isOpen={modalImport} toggle={toggleModalImport}>
            <ModalHeader toggle={toggleModalImport}>
              Import Multiple Materials Data
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={handleImportSubmit}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-project">
                    Project Name
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-project"
                    type="select"
                    name="p_id"
                    onChange={handleInputChange}
                    value={reqmaterial.p_id}
                    required
                  >
                    <option value="">Select Project Name</option>
                    {project && project.length > 0 ? (
                      project.map((option) => (
                        <option key={option.p_id} value={option.p_id}>
                          {option.p_name}
                        </option>
                      ))
                    ) : (
                      <option value="">No projects available</option>
                    )}
                  </Input>
                </FormGroup>
    
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-manager">
                    General Manager
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-manager"
                    type="select"
                    name="g_m_id"
                    onChange={handleInputChange}
                    value={reqmaterial.g_m_id}
                    required
                  >
                    <option value="">Select General Manager</option>
                    {Array.isArray(projectmanager) && projectmanager.length > 0 ? (
                      projectmanager.map((option) => (
                        <option key={option.emp_id} value={option.emp_id}>
                          {option.emp_name + " [" + option.role + "]"}
                        </option>
                      ))
                    ) : (
                      <option value="">No General Managers available</option>
                    )}
                  </Input>
                </FormGroup>
    
                <FormGroup>
                    <label className="form-control-label" htmlFor="input-status">
                      Materials Priority{" "}
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-status"
                      type="select"
                      name="mat_priority"
                      onChange={handleInputChange}
                      value={reqmaterial.mat_priority}
                      required
                    >
                      <option value="">Select Priority</option>
                      {shopName.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
    
                <FormGroup>
                  <Label for="importFile">Upload File</Label>
                  <Input
                    type="file"
                    name="importFile"
                    id="importFile"
                    accept=".csv, .xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
                    onChange={handleImportFileUpload}
                  />
                  {importedFileDetails && (
                    <div className="mt-2">
                      <small>
                        File: {importedFileDetails.fileName}| Uploaded:{" "}
                        {importedFileDetails.uploadTime}
                      </small>
                    </div>
                  )}
                </FormGroup>
                <div className="text-center">
                  <Button 
                    style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white'}} 
                    type="submit"
                    disabled={isImporting}
                  >
                    {isImporting ? (
                      <>
                        <i className="fas fa-spinner fa-spin mr-2"></i>
                        Importing...
                      </>
                    ) : (
                      'Import'
                    )}
                  </Button>
                </div>
              </Form>
            </ModalBody>
          </Modal>
    
          <Modal
            isOpen={showDeleteConfirmation}
            toggle={() => setShowDeleteConfirmation(false)}
          >
            <ModalHeader>Confirm Deletion</ModalHeader>
            <ModalBody>Are you sure you want to delete ?</ModalBody>
            <div className="modal-footer">
            <Button
              color="danger"
              onClick={() =>
                handleDeleteConfirmation(true, deleteProjectName)
              }
            >
              Yes
            </Button>
              <Button
                color="secondary"
                onClick={() => setShowDeleteConfirmation(false)}
              >
                No
              </Button>
            </div>
          </Modal>
    
          {modalEmployee && modalEmployee && (
            <Modal isOpen={modalOpen} toggle={toggleModalView}>
              <ModalHeader toggle={toggleModalView}>Material View</ModalHeader>
              <ModalBody>
                <div className="row">
                  <div className="col-md-12">
                    <div className="">
                      <label
                        className="border p-2 rounded font-weight-bold"
                        style={{ width: "155px" }}
                      >
                        Material Name
                      </label>
                      <label className=" p-2 rounded font-weight-bold m-1 ">
                        :
                      </label>
                      <label className="border p-2 rounded ">
                        {modalEmployee.mat_name}
                      </label>
                    </div>
                    <div>
                      <label
                        className="border p-2 rounded font-weight-bold "
                        style={{ width: "155px" }}
                      >
                        Budget
                      </label>
                      <label className=" p-2 rounded font-weight-bold m-1 ">
                        :
                      </label>
                      <label className="border p-2 rounded ">
                        {modalEmployee.mat_money}
                      </label>
                    </div>
                    <div>
                      <label
                        className="border p-2 rounded font-weight-bold "
                        style={{ width: "155px" }}
                      >
                        Quantity
                      </label>
                      <label className=" p-2 rounded font-weight-bold m-1 ">
                        :
                      </label>
                      <label className="border p-2 rounded ">
                        {modalEmployee.mat_quantity}
                      </label>
                    </div>
                    <div>
                      <label
                        className="border p-2 rounded font-weight-bold "
                        style={{ width: "155px" }}
                      >
                        Priority
                      </label>
                      <label className=" p-2 rounded font-weight-bold m-1 ">
                        :
                      </label>
                      <label className="border p-2 rounded ">
                        {modalEmployee.Priority}
                      </label>
                    </div>
                    <div>
                      <label
                        className="border p-2 rounded font-weight-bold "
                        style={{ width: "155px" }}
                      >
                        Date
                      </label>
                      <label className=" p-2 rounded font-weight-bold m-1 ">
                        :
                      </label>
                      <label className="border p-2 rounded ">
                        {modalEmployee.Date_Time}
                      </label>
                    </div>
                    <div>
                      <label
                        className="border p-2 rounded font-weight-bold "
                        style={{ width: "155px" }}
                      >
                        General Manager
                      </label>
                      <label className=" p-2 rounded font-weight-bold m-1 ">
                        :
                      </label>
                      <label className="border p-2 rounded ">
                        {modalEmployee.mat_status}
                      </label>
                    </div>
                    <div>
                      <label
                        className="border p-2 rounded font-weight-bold "
                        style={{ width: "155px" }}
                      >
                        Store Manager
                      </label>
                      <label className=" p-2 rounded font-weight-bold m-1 ">
                        :
                      </label>
                      <label className="border p-2 rounded ">
                        {modalEmployee.store_status || "N/A"}
                      </label>
                    </div>
                    <div>
                      <label
                        className="border p-2 rounded font-weight-bold "
                        style={{ width: "155px" }}
                      >
                        Action
                      </label>
                      <label className=" p-2 rounded font-weight-bold m-1 ">
                        :
                      </label>
                      <label className="border p-2 rounded ">
                        {modalEmployee.store_report || "N/A"}
                      </label>
                    </div>
                    {
                      imagesArray.length > 0 && (
                    <div>
                      <label
                        className="border p-2 rounded font-weight-bold "
                        style={{ width: "155px" }}
                      >
                        Uploaded Images
                      </label>
                      <label className=" p-2 rounded font-weight-bold m-1 ">
                        :
                      </label>
                      <Carousel
                        activeIndex={activeIndex1}
                        next={next1}
                        previous={previous1}
                      >
                        <CarouselIndicators
                          items={imagesArray}
                          activeIndex={activeIndex1}
                          onClickHandler={goToIndex1}
                        />
    
                        {slides1}
    
                        <CarouselControl
                          direction="prev"
                          directionText="Previous"
                          onClickHandler={previous1}
                        />
                        <CarouselControl
                          direction="next"
                          directionText="Next"
                          onClickHandler={next1}
                        />
                      </Carousel>
                    </div>
    
                      )
                    }
                  </div>
                </div>
              </ModalBody>
            </Modal>
          )}

          {/* Multiple Materials Modal */}
          {multipleMaterialsData && isMultipleMaterials && (
            <Modal isOpen={modalOpen} toggle={toggleModalView} size="xl">
              <ModalHeader toggle={toggleModalView}>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <span>Multiple Materials View ({multipleMaterialsData.materials.length} materials)</span>
                  <Button
                    color="success"
                    size="sm"
                    onClick={handleDownloadMultipleMaterials}
                    style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                  >
                    <i className="fas fa-download mr-1"></i>
                    Download Excel
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {/* Metadata Section */}
                <div className="row mb-4">
                  <div className="col-md-12">
                    <h6 className="text-muted mb-3">Request Information</h6>
                    <div className="row">
                      <div className="col-md-3">
                        <div className="border p-2 rounded">
                          <small className="text-muted d-block">Priority</small>
                          <strong>{multipleMaterialsData.metadata.Priority || "N/A"}</strong>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="border p-2 rounded">
                          <small className="text-muted d-block">Date</small>
                          <strong>{multipleMaterialsData.metadata.Date_Time || "N/A"}</strong>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="border p-2 rounded">
                          <small className="text-muted d-block">General Manager</small>
                          <strong>{multipleMaterialsData.metadata.mat_status || "N/A"}</strong>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="border p-2 rounded">
                          <small className="text-muted d-block">Store Manager</small>
                          <strong>{multipleMaterialsData.metadata.store_status || "N/A"}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Materials Table */}
                <div className="row">
                  <div className="col-md-12">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6 className="text-muted mb-0">Materials List</h6>
                      {multipleMaterialsData.materials.length > 5 && (
                        <div className="d-flex align-items-center">
                          <span className="mr-2 text-muted small">Show:</span>
                          <Dropdown
                            isOpen={modalEntriesDropdownOpen}
                            toggle={() => setModalEntriesDropdownOpen(!modalEntriesDropdownOpen)}
                            size="sm"
                          >
                            <DropdownToggle caret size="sm" className="px-3">
                              {modalEntriesPerPage === multipleMaterialsData.materials.length ? "All" : modalEntriesPerPage}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={() => handleModalEntriesChange(5)}>5</DropdownItem>
                              <DropdownItem onClick={() => handleModalEntriesChange(10)}>10</DropdownItem>
                              <DropdownItem onClick={() => handleModalEntriesChange(15)}>15</DropdownItem>
                              <DropdownItem onClick={() => handleModalEntriesChange("All")}>All</DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      )}
                    </div>
                    <div className="table-responsive" style={{maxHeight: '400px', overflowY: 'auto'}}>
                      <Table striped bordered hover size="sm">
                        <thead className="thead-light" style={{position: 'sticky', top: 0, zIndex: 1}}>
                          <tr>
                            <th style={{width: '5%'}}>Sr. No</th>
                            <th style={{width: '35%'}}>Material Name</th>
                            <th style={{width: '15%'}}>Quantity</th>
                            <th style={{width: '15%'}}>Budget</th>
                            <th style={{width: '10%'}}>Unit Price</th>
                            <th style={{width: '20%'}}>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {getModalPaginatedMaterials().map((material, index) => {
                            const quantity = parseFloat(material.mat_quantity) || 0;
                            const price = parseFloat(material.mat_money) || 0;
                            const total = quantity * price;
                            
                            return (
                              <tr key={index}>
                                <td>{getModalSerialNumber(index)}</td>
                                <td>
                                  <div style={{wordBreak: 'break-word'}}>
                                    {material.mat_name || "N/A"}
                                  </div>
                                </td>
                                <td>{material.mat_quantity || "N/A"}</td>
                                <td>₹{material.mat_money || "N/A"}</td>
                                <td>₹{price.toFixed(2)}</td>
                                <td>₹{total.toFixed(2)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr className="font-weight-bold" style={{backgroundColor: '#f8f9fa'}}>
                            <td colSpan="5" className="text-right">Total Budget:</td>
                            <td>
                              ₹{multipleMaterialsData.materials.reduce((sum, material) => {
                                const quantity = parseFloat(material.mat_quantity) || 0;
                                const price = parseFloat(material.mat_money) || 0;
                                return sum + (quantity * price);
                              }, 0).toFixed(2)}
                            </td>
                          </tr>
                        </tfoot>
                      </Table>
                    </div>
                    
                    {/* Pagination Controls */}
                    {multipleMaterialsData.materials.length > 5 && getModalTotalPages() > 1 && (
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div className="text-muted small">
                          Showing {((modalCurrentPage - 1) * modalEntriesPerPage) + 1} to {Math.min(modalCurrentPage * modalEntriesPerPage, multipleMaterialsData.materials.length)} of {multipleMaterialsData.materials.length} materials
                        </div>
                        <nav>
                          <ul className="pagination pagination-sm mb-0">
                            <li className={`page-item ${modalCurrentPage === 1 ? 'disabled' : ''}`}>
                              <button
                                className="page-link"
                                onClick={() => handleModalPageChange(modalCurrentPage - 1)}
                                disabled={modalCurrentPage === 1}
                              >
                                Previous
                              </button>
                            </li>
                            {Array.from({ length: getModalTotalPages() }, (_, i) => i + 1).map((pageNumber) => (
                              <li key={pageNumber} className={`page-item ${pageNumber === modalCurrentPage ? 'active' : ''}`}>
                                <button
                                  className="page-link"
                                  onClick={() => handleModalPageChange(pageNumber)}
                                  style={{
                                    backgroundColor: pageNumber === modalCurrentPage ? '#d86f89' : 'transparent',
                                    borderColor: pageNumber === modalCurrentPage ? '#d86f89' : '#dee2e6',
                                    color: pageNumber === modalCurrentPage ? 'white' : '#007bff'
                                  }}
                                >
                                  {pageNumber}
                                </button>
                              </li>
                            ))}
                            <li className={`page-item ${modalCurrentPage === getModalTotalPages() ? 'disabled' : ''}`}>
                              <button
                                className="page-link"
                                onClick={() => handleModalPageChange(modalCurrentPage + 1)}
                                disabled={modalCurrentPage === getModalTotalPages()}
                              >
                                Next
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    )}
                  </div>
                </div>

                {/* Images Section */}
                {multipleMaterialsData.metadata.files && (
                  <div className="row mt-4">
                    <div className="col-md-12">
                      <h6 className="text-muted mb-3">Uploaded Images</h6>
                      <Carousel
                        activeIndex={activeIndex1}
                        next={next1}
                        previous={previous1}
                      >
                        <CarouselIndicators
                          items={multipleMaterialsData.metadata.files.split(",")}
                          activeIndex={activeIndex1}
                          onClickHandler={goToIndex1}
                        />
                        {getCarouselSlides()}
                        <CarouselControl
                          direction="prev"
                          directionText="Previous"
                          onClickHandler={previous1}
                        />
                        <CarouselControl
                          direction="next"
                          directionText="Next"
                          onClickHandler={next1}
                        />
                      </Carousel>
                    </div>
                  </div>
                )}
              </ModalBody>
            </Modal>
          )}

          {/* Date Range Filter Modal */}
          <Modal isOpen={dateRangeModalOpen} toggle={toggleDateRangeModal}>
            <ModalHeader toggle={toggleDateRangeModal}>
              <i className="fas fa-calendar-alt mr-2"></i>
              Filter by Date Range
            </ModalHeader>
            <ModalBody>
              <Form>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="startDate">Start Date</Label>
                      <Input
                        type="date"
                        id="startDate"
                        name="startDate"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        placeholder="Select start date"
                      />
                      <small className="text-muted">
                        Leave empty to show from beginning
                      </small>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="endDate">End Date</Label>
                      <Input
                        type="date"
                        id="endDate"
                        name="endDate"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        placeholder="Select end date"
                      />
                      <small className="text-muted">
                        Leave empty to show until current date
                      </small>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="d-flex justify-content-between">
                      <Button
                        color="secondary"
                        onClick={clearFilters}
                        size="sm"
                      >
                        Clear Dates
                      </Button>
                      <div>
                        <Button
                          color="secondary"
                          onClick={toggleDateRangeModal}
                          className="mr-2"
                          size="sm"
                        >
                          Cancel
                        </Button>
                        <Button
                          color="primary"
                          onClick={applyDateRange}
                          size="sm"
                          style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                        >
                          Apply Filter
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          {/* Success Alert Modal */}
          {showSuccessAlert && (
            <div style={{
              position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex',
              justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999,
              backdropFilter: 'blur(5px)'
            }}>
              <div style={{
                backgroundColor: '#fff', padding: '40px', borderRadius: '20px',
                boxShadow: '0 20px 40px rgba(216, 111, 137, 0.3)', textAlign: 'center',
                maxWidth: '400px', width: '90%', border: '3px solid #d86f89',
                animation: 'slideIn 0.3s ease-out'
              }}>
                <div style={{
                  fontSize: '48px', 
                  color: '#d86f89', 
                  marginBottom: '20px',
                  animation: 'bounce 0.6s ease-in-out'
                }}>✓</div>
                <h4 style={{ color: '#28a745', marginBottom: '15px', fontWeight: 'bold' }}>Success!</h4>
                <p style={{ color: '#333', fontSize: '16px', marginBottom: '30px' }}>{successMessage}</p>
                <Button
                  style={{
                    background: 'linear-gradient(135deg, #d86f89, #ff8fa3)',
                    border: 'none',
                    color: 'white',
                    padding: '12px 30px',
                    borderRadius: '25px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '0 6px 20px rgba(216, 111, 137, 0.3)',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setShowSuccessAlert(false);
                    setSuccessMessage('');
                    // Refresh the page to show updated data
                    window.location.reload();
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 8px 25px rgba(216, 111, 137, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 6px 20px rgba(216, 111, 137, 0.3)';
                  }}
                >
                  OK
                </Button>
              </div>
            </div>
          )}
        </>
  );
};

export default Materials;